import {QAAnswer} from 'main/stores/questions';
import { observable, action, makeObservable } from 'mobx';
import Question from './Question';
import AttachedDocument from 'shared/stores/documents/AttachedDocument';
import _ from 'lodash';

class Answer extends QAAnswer {
  value;
  attachment;
  _relations = {
    attachment: AttachedDocument,
    question: Question
  };

  constructor(other) {
    super();

    makeObservable(this, {
      value: observable,
      attachment: observable,
      removeFile: action,
      mergeFile: action,
      updateFile: action
    });

    this.merge(other);
  }

  removeFile() {
    this.attachment = null;
  }

  mergeFile(file) {
    this.merge({attachment: file});
  }

  updateFile(files) {
    const file = _.head(files);
    file ? this.mergeFile(file) : this.removeFile();
  }
}

export default Answer;
